import {Component, OnInit} from '@angular/core';
import {LoadingController, ModalController} from '@ionic/angular';
import {NewDocumentService} from '../../services/new-document.service';
import {ServiceJobDetailsPage} from '../service-job-details/service-job-details.page';
import {ServiceJobDTOModel} from '../../models/service-job-DTO.model';
import {RefreshdatabaseService} from '../../services/database/refreshdatabase.service';
import {ConfigurationModel} from '../../models/configuration.model';
import {ConfigurationService} from '../../services/configuration.service';
import {TestConnectionService} from '../../services/test-connection.service';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {BarcodescannerComponent} from '../barcodescanner/barcodescanner.component';
import {PicturesPermissionService} from '../../services/pictures-permission.service';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { ScanBarcodeService } from 'src/app/services/scan-barcode.service';
import { DetaillineDTOModel } from 'src/app/models/detaillineDTO.model';
import { GeneralService } from 'src/app/services/general.service';
import { BarcodeOptions } from 'src/app/definitions/barcode-options';
import { ServiceJobFiltersPage } from '../service-job-filters/service-job-filters.page';
import { WorkshopConfigurationModel } from 'src/app/models/workshop-configuration.model';
import { MobileConfigurationModel } from 'src/app/models/mobile-configuration.model';
import { ReturnDocProcessingModel } from 'src/app/models/return-doc-processing.model';
import { JobListService } from 'src/app/services/database/resource/job-list.service';
import { ignoreElements } from 'rxjs/operators';
import { LokijsService } from 'src/app/services/database/lokijs.service';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { CustomerServiceJobDetailsPage } from '../customer-service-job-details/customer-service-job-details.page';

@Component({
    selector: 'app-service-job-list',
    templateUrl: './service-job-list.page.html',
    styleUrls: ['./service-job-list.page.scss'],
})

export class ServiceJobListPage implements OnInit {
    JOB_STATUS_ASSIGNED=2;
    JOB_STATUS_VERIFIED=200;

    jobList: ServiceJobDTOModel[];
    config: ConfigurationModel;
    queryText = '';
    loading: any;
    //customerJobs = true;
    //workshopJobs = true;

    toggleButtonText: string;
    toggleButtonStyle: string;
    toggleSwipeText: string;
    toggleSwipeStyle: string;
    workshopConfiguration: WorkshopConfigurationModel;
    loadingJobs: boolean;

    modalPage: any;

    filterByCollectedAndVerified: boolean;
    mobileConfiguration: MobileConfigurationModel = new MobileConfigurationModel();

    tempJobList: ServiceJobDTOModel[];

    constructor(private modalController: ModalController,
                private newDocumentService: NewDocumentService,
                private refreshDB: RefreshdatabaseService,
                private loadingController: LoadingController,
                private configService: ConfigurationService,
                private testConnection: TestConnectionService,
                private barcodeScanner: BarcodeScanner,
                private scanBarcodeService: ScanBarcodeService,
                private stateManager: StateManagerService,
                private generalService: GeneralService,
                private barcodeOptions: BarcodeOptions,
                private collectionNames: CollectionsNames,
                private picturesPermission: PicturesPermissionService,
                private stateManagerService: StateManagerService,
                private generalServices: GeneralService,
                private jobListService: JobListService,
                private loki: LokijsService) {
    }

    async ngOnInit() {
        // await this.loadingPopulateJobs();
        this.workshopConfiguration = {showCustomerJobs: true, showWorkshopJobs :true , showVerifiedJobs:false,jobOrdering:'ascending'};
        this.config = await this.configService.getConfiguration();
        this.mobileConfiguration = this.stateManagerService.getCollection(this.collectionNames.MOBILECONFIGURATION);

        console.log('Workshop Job Configuration');
        console.log( this.config );  
        console.log('MobileConfiguration');
        console.log( this.mobileConfiguration );      

        if( !this.config.workshopConfiguration ){
            this.config.workshopConfiguration = {showCustomerJobs: true, showWorkshopJobs :true , showVerifiedJobs:false,jobOrdering:'ascending'};
            await this.configService.saveConfiguration( this.config );
        }
        this.workshopConfiguration = this.config.workshopConfiguration;


        // need mobileConfiguration to sort this.

        this.redrawToggleButtonStyle();

        await this.populateJobs();

    }

    async ionViewWillEnter() {
        this.config = await this.configService.getConfiguration();
        this.mobileConfiguration = this.stateManagerService.getCollection(this.collectionNames.MOBILECONFIGURATION);

        console.log('Workshop Job Configuration');
        console.log( this.config );        

        if( !this.config.workshopConfiguration ){
            this.config.workshopConfiguration = {showCustomerJobs: true, showWorkshopJobs :true , showVerifiedJobs:false,jobOrdering:'ascending'};
            await this.configService.saveConfiguration( this.config );
        }
        this.workshopConfiguration = this.config.workshopConfiguration;
        this.redrawToggleButtonStyle();
        
    }


    async loadingPopulateJobs() {
        await this.loadingController.create({
            message: 'Loading Jobs...',
            translucent: true,
            // cssClass: 'custom-class custom-loading'
        }).then((overlay) => {
            this.loading = overlay;
            console.log(this.loading);
            this.loading.present();
        });
        this.populateJobs().then(data => {
            this.loading.dismiss();
        }).catch(() => {
            this.loading.dismiss();
        });
    }

    async loadingMessage(){
        await this.loadingController.create({
            message: 'Loading ...',
            translucent: true,
            // cssClass: 'custom-class custom-loading'
        }).then((overlay) => {
            this.loading = overlay;
            console.log(this.loading);
            this.loading.present();
        });
    }

    async populateJobs() {
        this.tempJobList = this.stateManager.getCollection(this.collectionNames.SERVICEJOB);
        this.filterJobs();
        try {
            this.loadingJobs = true;
            await this.testConnection.pingServer();
            await this.refreshDB.refreshJobList();
            //await this.refreshDB.refreshJobListResource();
            this.tempJobList = this.stateManager.getCollection(this.collectionNames.SERVICEJOB);
            this.filterJobs();
        } catch (e) {
        }

        //this.jobList = this.stateManager.getCollection(this.collectionNames.SERVICEJOB);


        this.loadingJobs = false;
        console.log(this.jobList);

       

    }


    cancelService() {
        this.modalController.dismiss();
    }

    async openModalJobDetails(job: ServiceJobDTOModel) {
        await this.loadingMessage();
        await this.refreshDB.refreshJobListResource();
        if (!job) {
            job = this.newDocumentService.buildNewServiceJobObj();
        }
        
        const document = this.newDocumentService.buildServiceJobDocumentBean(job);


        this.loading.dismiss(); // dismiss loading popup


        if( document.serviceJob.jobTypeId !== 4 && document.serviceJob.jobTypeId !== 11 ){
            this.modalPage = ServiceJobDetailsPage;
        }else{
            this.modalPage = CustomerServiceJobDetailsPage;
        }
        

        const modal = await this.modalController.create({
            component: ServiceJobDetailsPage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                document: document
            }
        });

        modal.onDidDismiss().then(data => {
            if (data.data) {
                this.modalController.dismiss();
            } else {
                this.populateJobs();
            }
        });
        return await modal.present();
    }

    async refreshDocs(event: any) {
        await this.populateJobs();
        event.target.complete();
    }

    async filterJobs() {
        //let tempJobList = this.jobList; // this.stateManager.getCollection('servicejob') as ServiceJobDTOModel[];

        console.log("workshop filtering : " + this.workshopConfiguration.jobOrdering );

        if( this.workshopConfiguration.jobOrdering === 'ascending'){
            this.tempJobList.sort((a, b) => (a.jobNumber > b.jobNumber) ? 1 : -1);
        }else{
            this.tempJobList.sort((a, b) => (a.jobNumber > b.jobNumber) ? -1 : 1);
        }
        this.tempJobList = this.tempJobList.filter(tempJob => {
            return true;
        });
        
        if (!this.workshopConfiguration.showCustomerJobs) {
            this.tempJobList = this.tempJobList.filter(tempJob => {
                return !!tempJob.servicedItem.pdesc && !!tempJob.servicedItem.reg;
            });
        }
        if (!this.workshopConfiguration.showWorkshopJobs) {
            this.tempJobList = this.tempJobList.filter(tempJob => {
                return !tempJob.servicedItem.pdesc && !tempJob.servicedItem.reg;
            });
        }

        if( this.mobileConfiguration.mobilehireFilterByCollectedAndVerified ) { // mobile configuration need for this verified / collected stuff.
     
                
                this.tempJobList = this.tempJobList.filter(tempJob => {

                    console.log(tempJob)
                    if (this.workshopConfiguration.showVerifiedJobs){
                        return tempJob.jobStatus === 200;
                    }else{
                        return tempJob.jobStatus !== 200;
                    }
                        
                });
        }

        this.jobList = this.tempJobList;
    }

    async scanBarcode() {
        await this.picturesPermission.checkPermissions();
        const job = this.newDocumentService.buildNewServiceJobObj();
        const document = this.newDocumentService.buildServiceJobDocumentBean(job);

        await this.picturesPermission.checkPermissions();
        this.barcodeScanner.scan(this.barcodeOptions.options).then(barcode => {
            console.log(barcode.text);
            this.handleScanResult(job,barcode.text);
        }).catch(err => {
            console.log(err);
        });


       /* const modal = await this.modalController.create({
            component: BarcodescannerComponent,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                console.log('Data REturned !!');
                console.log(dataReturned);
                job.servicedItem = dataReturned.data;
                this.openModalJobDetails(job);
            }
        });
        return await modal.present();*/
    }

    async handleScanResult(job,event) {
        console.log('Scan Result');
        console.log(event);
        let equipment = this.scanBarcodeService.findPlantItemByExactBarcode(event) as DetaillineDTOModel;
        if (equipment) {
            if (!equipment.qty) {
                equipment.qty = 1;
            }
            equipment = JSON.parse(JSON.stringify(equipment));
            job.servicedItem = equipment;
            this.openModalJobDetails(job);
        } else {
            await this.generalService.createToast('No match with barcode: ' + event);
        }
    }

 

    async showFilters() {
        const modal = await this.modalController.create({
            component: ServiceJobFiltersPage,
            backdropDismiss: false,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'workshopConfiguration': this.workshopConfiguration
            }
        });


        modal.onDidDismiss().then((dataReturned) => {
            this.tempJobList = this.stateManager.getCollection(this.collectionNames.SERVICEJOB);
            this.filterJobs();
            this.configService.hardSaveConfiguration(this.config);
            console.log(this.config);
        });

        return await modal.present();
    }

    async toggleVerifiedJobs(){
        this.toggleShowVerifiedJobs();
       

        this.config.workshopConfiguration.showVerifiedJobs = !this.config.workshopConfiguration.showVerifiedJobs;

        console.log( this.workshopConfiguration.showVerifiedJobs );
        console.log( this.config.workshopConfiguration.showVerifiedJobs );
        
        this.tempJobList = this.stateManager.getCollection(this.collectionNames.SERVICEJOB);
        this.filterJobs();
        this.configService.hardSaveConfiguration(this.config);
        this.redrawToggleButtonStyle();
    }

    toggleShowVerifiedJobs(){
       if( this.workshopConfiguration.showVerifiedJobs){
            this.workshopConfiguration.showVerifiedJobs = false;
        }else{
            this.workshopConfiguration.showVerifiedJobs = true;
        }

        if( this.config.workshopConfiguration.showVerifiedJobs){
            this.config.workshopConfiguration.showVerifiedJobs = false;
        }else{
            this.config.workshopConfiguration.showVerifiedJobs = true;
        }  
    }

    redrawToggleButtonStyle(){
        if( this.workshopConfiguration.showVerifiedJobs ){
            this.toggleButtonText = "Verified Jobs";
            this.toggleButtonStyle = "success"
            this.toggleSwipeText="Pending Jobs";
            this.toggleSwipeStyle="warning";
        }else{
            this.toggleButtonText = "Pending Jobs";
            this.toggleButtonStyle = "warning";
            this.toggleSwipeText="Verified Jobs";
            this.toggleSwipeStyle="success";
        }
    }

    async handleAssigningDocument(job , assignSlider ){
        console.log("Reassigning Job");
        console.log(job);
        assignSlider.close();

        var returnDTO = await this.assigningJobTypeOnBackend(job);

        if( returnDTO.errorMessage.length > 0 ){
            this.generalServices.createToast(returnDTO.errorMessage,2000,'danger');
            return;
        }else{
            this.generalServices.createToast("Updated Job",1000,'success');
            if(this.workshopConfiguration.showVerifiedJobs ){
                console.log('Local To Pending');
                job.jobStatus = this.JOB_STATUS_ASSIGNED;
    
            }else{
                console.log('Local to Verified');
                job.jobStatus = this.JOB_STATUS_VERIFIED;
            
            }
            this.loki.upsert(this.collectionNames.SERVICEJOB,'id',job);
            this.tempJobList = this.stateManager.getCollection(this.collectionNames.SERVICEJOB);
            this.filterJobs();
        }

    }

    async assigningJobTypeOnBackend(job) {
        var returnDTO: ReturnDocProcessingModel = new ReturnDocProcessingModel();
        returnDTO.errorMessage="Failed to Assign";
        
        await this.loadingController.create({
            message: 'Updating Job Status ...',
            translucent: true,
            cssClass: 'custom-class custom-loading'
        }).then((overlay) => {
            this.loading = overlay;
            this.loading.present();
        });
        try {
           if(this.workshopConfiguration.showVerifiedJobs){
                console.log('To Pending');
                returnDTO = await this.jobListService.postJobStatusUpdate(job.id, this.JOB_STATUS_ASSIGNED  ) as ReturnDocProcessingModel;
           }else{
                console.log('To Verified');
                returnDTO = await this.jobListService.postJobStatusUpdate(job.id, this.JOB_STATUS_VERIFIED ) as ReturnDocProcessingModel;
           }
           
        } catch (e) {
            console.log(e);
            this.generalServices.createToast('No connection with the server');
            return returnDTO;

        } finally {
            this.loading.dismiss();
            return returnDTO;
        }


    }

}
